import i18n from "../../i18n";
import { getI18n, withI18n } from "react-i18next";
import qs from "query-string";
import { CWBAPI } from "cwb-react";
import { client } from "../apiClient";

export const localeKeys = { en: 0, fr: 1, en_uk: 2, es: 3, nb: 99 };

export const detectBrowserLang =
  (navigator.languages && navigator.languages[0]) ||
  navigator.language ||
  navigator.userLanguage;

export const setBrowserLang = () => {
  const browserLang = detectBrowserLang.toLowerCase();
  if (browserLang === "en-gb") {
    i18n.changeLanguage("en_uk");
  } else if (localeKeys[browserLang.split("-")[0]]) {
    i18n.changeLanguage(browserLang.split("-")[0]);
  } else {
    i18n.changeLanguage("en");
  }
};

export const validateEmail = (email) => {
  let lowerEmail = email.toLowerCase();
  return /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(
    lowerEmail
  );
};

export const redirectToLogin = (search) =>
  (window.location.href = `${CWB_API_ENV.domain}/login${search || ""}`);

export const redirectToRegister = () =>
  (window.location.href = `${CWB_API_ENV.register}`);

export const redirectToHome = () =>
  (window.location.href = `${CWB_API_ENV.domain}`);

export const redirectToNewRep = (search) =>
  (window.location.href = `/login/new-presentation${search || ""}`);

export const redirectToCWBLabs = (isLangSpanish) => {
  window.location.href = `${CWB_API_ENV.cwblabs}${isLangSpanish ? "/es" : ""}`;
};

// Producer accounts must pass phone verification before redirect. Returns { isProducer, redirected }.
export const checkProducerPhoneVerification = async (decodedToken, accessToken) => {
  const isProducerType = parseInt(decodedToken.UserType) === 2;
  if (!isProducerType) {
    return { isProducer: false, redirected: false };
  }

  let api = await import(`cwb-react/dist/${CWB_API_FILE}`);
  let localApi = await import(`shared/api`);
  client.api = new CWBAPI(
    { ...api.default, ...localApi.default },
    CWB_API_ENV,
    CWB_USE_MOCK_ENV
  );

  client.api.axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

  const phoneCheckResp = await client.api.userPhone.loginCheck(decodedToken.WebSessionKey);
  const isPhoneVerified = !phoneCheckResp.data.required || phoneCheckResp.data.isVerified;
  const isProducer = phoneCheckResp.data.isProducer;

  if (!isPhoneVerified) {
    window.location.href = `${CWB_API_ENV.producer}/sign-up/phone-1?k=${decodedToken.WebSessionKey}&isProducer=${isProducer ? '1' : '0'}`;
    return { isProducer, redirected: true };
  }

  return { isProducer, redirected: false };
};

export const getSupportEmail = "support@castingworkbook.com";

export const hasOpenBdParams = (location) => {
  if (!location) return false;
  const params = qs.parse(location.search);
  return (
    params &&
    params.page &&
    params.page.toLowerCase() === "openbd" &&
    params.bd &&
    Number(params.bd) &&
    Number(params.bd) > 0
  );
};

export const getRegisterRedirect = (location, labs) => {

  let defaultRedirect = "";
  if (labs) {
    const isLangSpanish = getI18n().language === "es";
    if (isLangSpanish) {
      defaultRedirect = `${CWB_API_ENV.signUp}/select-account-type`;
    } else {
      defaultRedirect = `${CWB_API_ENV.signUp}/register/cwblabs/actor`;
    }
  } else {
    defaultRedirect = CWB_API_ENV.register;
  }

  if (!location || !location.search) return defaultRedirect;

  const allParams = qs.parse(location.search);
  let allowed = whiteListQueryString(location.search);

  let finalUrl = defaultRedirect;
  if (hasOpenBdParams(location)) {
    delete allowed.page;

    // not need to use page=openbd in the registrial trial (special signup)
    let current = `${CWB_API_ENV.registerTrial}?bd=${allParams.bd}`;
    let roleTarget = allParams.roleid || allParams.roleId || "";
    if (roleTarget) {
      current = current + `&roleid=${roleTarget}`
    }
    if (allParams.src) {
      current = current + `&src=${allParams.src}`
    }

    delete allowed.roleid;
    delete allowed.roleId;
    delete allowed.bd;

    finalUrl = current;
  }

  if (hasOpenBdParams(location) || finalUrl.indexOf("?") > -1) {
    finalUrl = finalUrl + "&";
  } else {
    finalUrl = finalUrl + "?";
  }

  const queryStringResult = JSON.stringify(allowed);
  if (queryStringResult.trim() != '{}' && queryStringResult.trim() != '{ }') {
    finalUrl = finalUrl + `${qs.stringify(allowed)}`;
  }

  if (finalUrl.endsWith("&") || finalUrl.endsWith("?")) {
    finalUrl = finalUrl.substring(0, finalUrl.length - 1);
  }

  return finalUrl;
};


export const whiteListQueryString = (searchQueryStringText, loginRedirect) => {
  let allParams;
  if (
    typeof searchQueryStringText === 'object' &&
    searchQueryStringText !== null
  ) {
    allParams = searchQueryStringText;
  } else {
    allParams = qs.parse(searchQueryStringText);
  }

  let allowed = {
    refr: allParams.refr,
    redirect: allParams.redirect,
    returnUrl: allParams.returnUrl,
    cwblabs: allParams.cwblabs,
    page: allParams.page,
    email: allParams.email,
    code: allParams.code,
    coupon: allParams.coupon,
    bd: allParams.bd,
    roleid: allParams.roleid || allParams.roleId,
    targetId: allParams.targetId,
    product: allParams.product,
    address: allParams.address,
    src: allParams.src,
    utm: allParams.utm,
    utm_compaign: allParams.utm_compaign,
    utm_content: allParams.utm_content,
    utm_source: allParams.utm_source,
    utm_medium: allParams.utm_medium,
    promo: allParams.promo,
    companyId: allParams.companyId,
    signup: allParams.signup,
    signUp: allParams.signUp || allParams.Signup,
    existing: allParams.existing,
    pp: allParams.pp
  };

  let initialKeys = Object.keys(allowed);
  for (let index = 0; index < initialKeys.length; index++) {
    const element = initialKeys[index];
    const propValue = allowed[element];
    if (!propValue) {
      delete allowed[element];
    }
  }

  if (allowed.page == "upgrade") {
    delete allowed.page;
  }


  if (
    (allowed.redirect &&
      (
        allowed.redirect.toLowerCase().indexOf("api.") <= -1
        || allowed.redirect.toLowerCase().indexOf("cwb-int-api.") <= -1
      )
    )
    || (allowed.returnUrl &&
      (
        allowed.returnUrl.toLowerCase().indexOf("api.") <= -1
        && allowed.returnUrl.toLowerCase().indexOf("cwb-int-api.") <= -1
      )
    )
  ) {
    if (loginRedirect) {
      delete allowed.returnUrl;
      delete allowed.redirect;
    }
    if (allowed.page && (allowed.page.toLowerCase() === "idp" || allowed.page.toLowerCase() === "idpt")) {
      delete allowed.page;
    }
  }

  return allowed;
}

export const redirectAuthenticated = (userType, webSessionKey, userId, queryStringData, token, isProducer=false) => {
  const ACTOR_SUBTYPE = "8";
  const AGENT_SUBTYPE = "3";
  const CASTING_SUBTYPE = "2";
  const ADMIN_SUBTYPE = "1";

  const handleAccountRedirect = () => {
    if (
      ["academy", "cwblabs", "cwblive", "canny", "canny-sso"].includes(
        queryStringData.redirect.toLowerCase()
      )
    ) {
      queryStringData.tk = "";
      queryStringData.k = webSessionKey;

      if (queryStringData.redirect.toLowerCase() === "academy") {
        window.location.href = `${CWB_API_ENV.cwb
          }/auth/academy/redirect?${qs.stringify(queryStringData)}`;
        return true;
      } else if (queryStringData.redirect.toLowerCase() === "cwblabs") {
        window.location.href = `${CWB_API_ENV.cwb
          }/auth/cwblabs/redirect?${qs.stringify(queryStringData)}`;
        return true;
      } else if (queryStringData.redirect.toLowerCase() === "cwblive") {
        window.location.href = `${CWB_API_ENV.cwb
          }/auth/cwblive/redirect?${qs.stringify(queryStringData)}`;
        return true;
      } else if (queryStringData.redirect.toLowerCase().startsWith("canny")) {
        window.location.href = `${CWB_API_ENV.cwb
          }/auth/jwt/canny-sso?${qs.stringify(queryStringData)}`;
        return true;
      } else {
        return false;
      }
    }
  };

  if (queryStringData.page && queryStringData.returnUrl) {
    const targetPage = queryStringData.page.toLowerCase().trim();
    if (targetPage == "idp" || targetPage == "idpt" || targetPage == "sso" || targetPage.startsWith("canny")) {
      let redirectTarget = decodeURIComponent(queryStringData.returnUrl);

      const allowed = whiteListQueryString(queryStringData, true)
      if (!allowed.k) {
        allowed.k = webSessionKey
      }

      if (targetPage != "idp") {
        allowed.token = token;
      }

      const queryStringResult = JSON.stringify(allowed);
      if (queryStringResult.trim() != '{}' && queryStringResult.trim() != '{ }') {
        if (redirectTarget.indexOf("?") > -1) {
          redirectTarget = redirectTarget + "&";
        } else {
          redirectTarget = redirectTarget + "?";
        }

        redirectTarget = redirectTarget + `${qs.stringify(allowed)}`;
      }

      if (redirectTarget.endsWith("&") || redirectTarget.endsWith("?")) {
        redirectTarget = redirectTarget.substring(0, finalUrl.length - 1);
      }

      //todo use domain variable
      if ((targetPage == "sso" ||
        targetPage.startsWith("canny")) ||
        (window.location.href.toLowerCase().indexOf(".thecwbint.com") <= -1 &&
          window.location.href.toLowerCase().indexOf(".castingworkbook.com") <= -1)
      ) {
        window.location.href = redirectTarget;
        return true;
      } else {
        if ((targetPage == "idp" || targetPage == "idpt") &&
          (window.location.href.toLowerCase().indexOf("ngrok.io") > -1)
        ) {
          window.location.href = redirectTarget;
          return true;
        }
        queryStringData.returnUrl = redirectTarget;
      }
    }
  }

  switch (userType) {
    case ACTOR_SUBTYPE:
      if (window.location.href.includes("pmtDetails")) {
        window.location.href = `${CWB_API_ENV.signUp}/actor/payment/details?k=${webSessionKey}`;
        return true;
      }

      // not using custom url
      // if (hasOpenBdParams(this.props.location)) {
      //   window.location.href = `${CWB_API_ENV.domain}/open-breakdown.asp?bd=${queryString.bd}&k=${webSessionKey}`;
      //   break;
      // }

      // needs to set authentication first
      // if ((queryStringData.canadianUpgrade || queryStringData.homeKit) && queryStringData.email) {
      //   let redirectResult = `${CWB_API_ENV.signUp}/actor/upgrade-to-pro${this.props.location.search}`;
      //   window.location.href = redirectResult;
      //   break;
      // }

      queryStringData.tk = webSessionKey;
      queryStringData.cid = userId;

      if (!queryStringData.page && (queryStringData.redirect)) {
        queryStringData.page = queryStringData.redirect;
      }

      const defaultActorRedirect = `${CWB_API_ENV.domain}/actorsworkbook/default.asp?${qs.stringify(queryStringData)}`;
      if (queryStringData.page && queryStringData.page.trim().toLowerCase() == "upgrade") {
        window.location.href = defaultActorRedirect;
      } else {
        if (queryStringData.redirect && handleAccountRedirect()) {
          return true;
        } else {
          window.location.href = defaultActorRedirect;
        }
      }
      break;
    case AGENT_SUBTYPE:
    case ADMIN_SUBTYPE:
    case CASTING_SUBTYPE:
      if (queryStringData.redirect) {
        if (handleAccountRedirect()) {
          return true;
        }
      }

      if (
        isProducer
        && userType === CASTING_SUBTYPE
        && CWB_API_ENV.enableCastlistsRedirect.toLowerCase() === "true"
      ) {
        queryStringData.k = webSessionKey;
        window.location = `${CWB_API_ENV.castlists}?${qs.stringify(queryStringData)}`;
        return true;
      } else {
        queryStringData.k = webSessionKey;
        window.location = `${CWB_API_ENV.domain
          }/castingworkbook/default2.asp?${qs.stringify(queryStringData)}`;
        return true;
      }
      break;
  }
  return false;
};
